var r="#211F20",e=function(r){if("number"==typeof r)return r/10+"rem"};export{r as DefaultTextColor,e as pxToRem};
